import HomeCollection from './HomeCollection';

export default HomeCollection;
